module.exports = __webpack_public_path__ + "h5/img/hongka_bg.7b3e69d8.png";